import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export interface Props {
    content?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesContent',
  props: {
    content: { default: '' }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!

  return (_openBlock(), _createBlock(_component_q_scroll_area, { style: {"width":"100%","height":"100%"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "reference-content",
        innerHTML: props.content
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})